export default __webpack_public_path__ + "static/media/513.caf11add.png";